import React, { useEffect, useRef, useState } from 'react';
import { Protected } from '@components/layout/Protected';
import { Box, Container, Typography, styled } from "@mui/material";
import { TableDataV2 } from '@/components/common/Tablev2';
import { Loading } from '@/components/common/Loading';
import { Props } from './IpsAccept.type';
import { ConfigurationIPService } from '@/service/services/ConfigurationIP.service';
import { ModalIpAccept } from '@/components/Modal/ModalIpAccept/ModalIpAccept';
import { ModalIpDelete } from '@/components/Modal/ModalIpDelete/ModalIpDelete';
import { companiesService } from '@/service/services/Companies.service';
import ___PHRASE from '@/service/translate/translateService';

const Div = styled('div')(({ theme }) => ({
    ...theme.typography.button,
    padding: theme.spacing(1),
    fontWeight: 'bold',
    fontSize: '20px',
    color: 'rgba(102, 102, 102, 0.4)',
}));

export const IpsAcceptView: React.FC<Props> = (props:any): JSX.Element => {

    const [loading, setLoading] = useState<boolean>(false);
    const [IpsAccept, setIpsAccept] = useState([]);
    const [showIpAcceptModal, setShowIpAcceptModal] = useState<boolean>(false);
    const [showIpAcceptDeleteModal, setShowIpAcceptDeleteModal] = useState<boolean>(false);
    const [actionSelected, setActionSelected] = useState<String>('');
    const [IpAcceptSelected, setIpAcceptSelected] = useState<String>('');

    const [ipAcessRequest, setIpAcessRequest] = useState<String>('');

    useEffect(() => {
        getIPAccessByCompany();
    },[]);

    const getIPAccessByCompany = async() => {
        setLoading(true);
        let ipAccess = '';

        await companiesService.getDataCompany().then((data) => {
            if(data?.data && data?.data?.ip_access_request) ipAccess = data.data.ip_access_request;
            setIpAcessRequest(data.data.ip_access_request);
        })

        if(ipAccess != '0'){
            await ConfigurationIPService.getIPAccessByCompany().then((data) => {
                setIpsAccept(data.data || []);
            })
        }
        setLoading(false);
    }

    function RecuperarData(value){
        console.log(value)
        setIpAcceptSelected(value)
    }

    return (
        <Protected>
            {loading && <Loading/>}
            <Container>

                {
                    ipAcessRequest && ipAcessRequest != '0' && !loading && (
                        <>
                        <TableDataV2
                            title={___PHRASE("ipsAceptadas")}
                            data={IpsAccept}
                            header={[
                                { name: 'rangeStart', label: ___PHRASE('rangoInicio'), filter: false, Chip: false },
                                { name: 'rangeEnd', label: ___PHRASE('rangoFinal'), filter: false, Chip: false },
                                { name: 'user_name', label: ___PHRASE('nombreDeUsuario'), filter: false, Chip: true },
                                { name: 'n_document', label: ___PHRASE('nDocumento'), filter: false, Chip: true },
                                { name: 'email', label: ___PHRASE('correoDeUsuario'), filter: false, Chip: true },
                            ]}
                            actionSelect={setActionSelected}
                            setModalSave={setShowIpAcceptModal}
                            setModalDelete={setShowIpAcceptDeleteModal}
                            status_action
                            RecuperarData={RecuperarData}
                            note_severity={'warning'}
                            note={___PHRASE('acceptIP')}
                        />
                        </>
                    )
                }
                {
                    ipAcessRequest && ipAcessRequest == '0' && !loading && (
                        <>
                        <Typography variant='h6' component='h1' gutterBottom className="tittle" sx={{ fontWeight:600, paddingTop:'23px'}}>
                            {___PHRASE("ipsAceptadas")}
                        </Typography>
                        <Box sx={{backgroundColor: 'rgba(224, 224, 224, 0.5)', padding: '15px', borderRadius: '10px', height:'150px', justifyContent: 'center', alignItems: 'center', display: 'flex', marginTop: '45px' }}>
                                <Div>{___PHRASE("laEmpresaNoCuentaConRestriccionPorIp")}</Div>
                        </Box>
                        </>
                    )
                }
                {
                    loading && (
                        <Box sx={{backgroundColor: 'rgba(224, 224, 224, 0.5)', padding: '15px', borderRadius: '10px', height:'150px', justifyContent: 'center', alignItems: 'center', display: 'flex', marginTop: '45px' }}>
                            <Div>{___PHRASE("cargandoDatosEspereUnMomento")}</Div>
                        </Box>
                    )
                }


            </Container>

            { 
                showIpAcceptModal && (
                <ModalIpAccept
                    open={showIpAcceptModal}
                    closeModal={()=>{setShowIpAcceptModal(false)}}
                    actionSelected={actionSelected}
                    onListIps={getIPAccessByCompany}
                    userIp={IpAcceptSelected}
                    clearState={()=>{setIpAcceptSelected('')}}
                />
                )
            }
            {
                actionSelected === 'delete' && (
                <ModalIpDelete
                    open={showIpAcceptDeleteModal}
                    closeModal={()=>{setShowIpAcceptDeleteModal(false)}}
                    actionSelected={actionSelected}
                    onListIps={getIPAccessByCompany}
                    userIp={IpAcceptSelected}
                    clearState={()=>{setIpAcceptSelected('')}}
                    type='accept'
                />
                )
            }
        
        </Protected>
    )
};